import React, { ReactElement } from 'react'

import { Col, PageHeader, Row, Tabs } from 'antd'

import ModalAjudaConfiguracaoArmazem from './ModalAjudaConfiguracaoArmazem'
import ModalConfigurarAlertas from './ModalConfigurarAlertas'
import ModalConfigurarArmazem from './ModalConfigurarArmazem'

const { TabPane } = Tabs

const ModalConfiguracoes = (): ReactElement => {
  return (
    <Col style={{ minHeight: '600px' }}>
      <Row justify="space-between">
        <PageHeader
          ghost={false}
          title="Configurações"
          style={{ width: '100%', padding: 0 }}
        />
      </Row>
      <Row>
        <Tabs defaultActiveKey="1" style={{ width: '100%' }}>
          <TabPane tab="Armazéns" key="1">
            <ModalConfigurarArmazem />
          </TabPane>
          {/* <TabPane tab="Macros" key="2">
            <p>Macros</p>
          </TabPane>
          <TabPane tab="Checklists" key="3">
            <p>Checklists</p>
          </TabPane> */}
          <TabPane tab="Alertas" key="4">
            <ModalConfigurarAlertas />
          </TabPane>
          <TabPane tab="Ajuda" key="5">
            <ModalAjudaConfiguracaoArmazem />
          </TabPane>
        </Tabs>
      </Row>
    </Col>
  )
}

export default ModalConfiguracoes
